module.exports = __webpack_public_path__ + "static/ghost-of-the-seas-ii_in-display-73411223ec1367374f0ff4b3432d51fd.jpg";